import CmsApiService from "@/services/CmsApiService.js";

const state = {
    hotDestinations: []
}

const getters = {
    hotDestinations: state => state.hotDestinations
}

const mutations = {
    UPDATE_HOT_DESTINATION(state, payload) {
        state.hotDestinations = payload;
    }
}

const actions = {
    setHotDestination({ commit }) {
        return new Promise((resolve) => {
            CmsApiService.getHotDestination().then(res => {
                console.log(res);
                let payload = [];
                if (res.data.length > 0) {
                    res.data.forEach((element) => {
                        if (element.isLive == "true" && element.status == "PUBLISH")
                            payload.push(element);
                    });
                }
                commit('UPDATE_HOT_DESTINATION', payload);
                resolve();
            }).catch(error => {
                commit('UPDATE_HOT_DESTINATION', []);
                resolve();
                throw new Error(`API ${error}`);
            });
        });
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}